import React, { useContext, useEffect, useState } from "react";
import {
  MeleeSearchContext,
  CartContext,
} from "../../utils/stateHandlers/contexts";
import _ from "lodash";
import { Link as DomLink } from "react-router-dom";
import { storage, api } from "../../utils";
import toast from "react-hot-toast";
import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import IconButton from "@mui/material/IconButton";
import Stack from "@mui/material/Stack";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Switch from "@mui/material/Switch";
import { styled } from "@mui/material/styles";

const CustomSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 34,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "& + .MuiSwitch-track": {
      opacity: 1,
      backgroundColor: "#e0b749",
    },
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#4280aa",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    boxSizing: "border-box",
  },
}));

export default function MeleeAddToCartPreview(props) {
  const { meleeState, meleeSearchDispatch } = useContext(MeleeSearchContext);
  const { cartPreview, openCartPreview, showCartSuccess } = meleeState;
  const { cartDispatch } = useContext(CartContext);
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const [terms, setTerms] = useState(false);
  const [partcode, setPartcode] = useState();
  const [quantityUnit, setQuantityUnit] = useState("ea");
  const [each, setEach] = useState();
  const [carat, setCarat] = useState();

  function addToCart() {
    const addToCartBody = {
      cart_id:
        storage.getStorageItem("cartId") !== "null"
          ? storage.getStorageItem("cartId")
          : JSON.parse(storage.getStorageItem("cartId")),
      partcode: {
        material: "D",
        product: partcode.product,
        dimension: partcode.dimension,
        finger_size: "",
        quantity: quantityUnit === "ea" ? each : carat,
        quantity_unit: quantityUnit === "ea" ? "EA" : "CT",
        carat_size: partcode.carat_size,
        Quantity: {
          ea: _.toString(each),
          ct: carat,
        },
        quantity_unit_provided: quantityUnit,
        message: specialInstructions,
      },
    };
    api
      .post("cart/add", addToCartBody)
      .then((res) => {
        if (res.isAxiosError) {
          const errorMessage = [];
          _.forEach(res.response.data.errors, function (error) {
            errorMessage.push(error);
          });
          console.log(errorMessage);
          toast.error(
            `There was an error processing your request. ${_.toString(
              errorMessage
            )}`
          );
        } else {
          cartDispatch({
            type: "updateCart",
            payload: {
              cart: res.data.items,
              cartCount: res.data.count,
            },
          });
          storage.setStorageItem("cartId", res.data.cart_id);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
    meleeSearchDispatch({ type: "setShowCartSuccess", payload: true });
  }

  function convert(number) {
    if (quantityUnit === "ea") {
      const convertBody = {
        id: cartPreview.id,
        quantity: number,
        unit: "EA",
      };
      api.post("melee/convert", convertBody).then((res) => {
        setCarat(res.data.quantity);
      });
    } else {
      const convertBody = {
        id: cartPreview.id,
        quantity: number,
        unit: "CT",
      };
      api.post("melee/convert", convertBody).then((res) => {
        setEach(res.data.quantity);
      });
    }
  }

  useEffect(() => {
    api.fetch(`melee/form/${cartPreview.id}`).then((res) => {
      const eachField = _.find(res.data.fields, function (field) {
        return field.name === "Quantity.ea";
      });
      const caratField = _.find(res.data.fields, function (field) {
        return field.name === "Quantity.ct";
      });
      setEach(eachField.default);
      setCarat(caratField.default);
      setPartcode(res.data.partcode);
    });
  }, [cartPreview]);

  return (
    <Dialog
      open={openCartPreview}
      onClose={() => {
        meleeSearchDispatch({ type: "setOpenCartPreview", payload: false });
        meleeSearchDispatch({ type: "setCartPreview", payload: {} });
      }}
      onBackdropClick={() => {
        meleeSearchDispatch({ type: "setOpenCartPreview", payload: false });
        meleeSearchDispatch({ type: "setCartPreview", payload: {} });
      }}
      maxWidth="sm"
      fullWidth={true}
    >
      {!showCartSuccess ? (
        <>
          <DialogTitle sx={{ backgroundColor: "#cfdde9" }}>
            <Typography variant="h3">
              {cartPreview.Collection} | {cartPreview.Shape} |{" "}
              {cartPreview.Color} {cartPreview.Clarity}
            </Typography>
            <IconButton
              aria-label="close"
              onClick={() => {
                meleeSearchDispatch({
                  type: "setOpenCartPreview",
                  payload: false,
                });
                meleeSearchDispatch({
                  type: "setCartPreview",
                  payload: {},
                });
              }}
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent>
            <Stack spacing={3} sx={{ marginTop: "1rem" }}>
              <Typography>
                <strong>Carat Range:</strong> {cartPreview.CaratRange}
              </Typography>
              <Typography>
                <strong>MM Range:</strong> {cartPreview.MmRange}
              </Typography>
              <Typography>
                Please enter either the amount each or the carat total weight
                that you would like to purchase:
              </Typography>
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="center"
              >
                <Typography>Each</Typography>
                <CustomSwitch
                  onChange={(event) =>
                    setQuantityUnit(event.target.checked ? "ct" : "ea")
                  }
                />
                <Typography>Carat Weight</Typography>
              </Stack>
              <Stack direction="row">
                <Typography>Quantity (EA)</Typography>
                <TextField
                  disabled={quantityUnit === "ea" ? false : true}
                  color="primary"
                  type="number"
                  size="small"
                  sx={{
                    width: "100%",
                    margin: "unset",
                  }}
                  value={each}
                  onChange={(e) => {
                    setEach(e.target.value);
                    convert(e.target.value);
                  }}
                />
              </Stack>
              <Stack direction="row">
                <Typography>Quantity (CT)</Typography>
                <TextField
                  disabled={quantityUnit === "ct" ? false : true}
                  color="primary"
                  type="number"
                  size="small"
                  sx={{
                    width: "100%",
                    margin: "unset",
                  }}
                  value={carat}
                  onChange={(e) => {
                    setCarat(e.target.value);
                    convert(e.target.value);
                  }}
                />
              </Stack>

              <Typography>
                Every effort is made to provide stones matching in size and
                quality. If a specific mm size is required, please provide the
                0.10mm range below (i.e 1.90-2.00mm)
              </Typography>
              <FormControlLabel
                label={
                  <Typography variant="cellFont">
                    I have read and agree to the{" "}
                    <DomLink
                      to={{ pathname: "/links/Company-Policies" }}
                      target="_blank"
                      rel="noreferrer"
                      className="underline"
                    >
                      Terms & Conditions
                    </DomLink>{" "}
                    *
                  </Typography>
                }
                control={
                  <Checkbox
                    checked={terms}
                    onChange={() => setTerms(terms ? false : true)}
                  />
                }
              />
              <TextField
                label="Special Instructions"
                multiline
                fullWidth
                rows={3}
                value={specialInstructions}
                onChange={(e) => setSpecialInstructions(e.target.value)}
              />
            </Stack>
            <Button
              className="float-right"
              variant="contained"
              color="success"
              onClick={() => addToCart()}
            >
              Add to Cart
            </Button>
          </DialogContent>
        </>
      ) : (
        <>
          <DialogTitle>Success!</DialogTitle>
          <DialogContent>
            Your selected diamonds have been added to your cart. Checkout now
            and place your order!
            <Stack direction="row" className="float-right" spacing={1}>
              <Button
                variant="contained"
                color="secondary"
                onClick={() =>
                  meleeSearchDispatch({
                    type: "setOpenCartPreview",
                    payload: false,
                  })
                }
              >
                Continue Shopping
              </Button>
              <DomLink
                to={{
                  pathname: "/cart",
                }}
              >
                <Button variant="contained">Checkout</Button>
              </DomLink>
            </Stack>
          </DialogContent>
        </>
      )}

      <Dialog
        open={showAlert}
        onClose={() => setShowAlert(false)}
        onBackdropClick={() => setShowAlert(false)}
      >
        <DialogTitle sx={{ fontSize: "1.6rem", fontWeight: "bold" }}>
          {`Terms & Conditions`}
          <IconButton
            aria-label="close"
            onClick={() => setShowAlert(false)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Typography gutterBottom sx={{ fontSize: "1.4rem" }}>
              Please accept the terms and conditions.
            </Typography>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </Dialog>
  );
}
